import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './UpsellSignUp.module.scss';
import AriUpsell from './AriUpsell';

const UpsellSignUp = ({ user, mobile }) => {
  if (user && user?.pro === false) {
    return <AriUpsell user={user} mobile={mobile} />;
  }

  if (!user) {
    return (
      <div
        className={`${styles.upsellContainer} ${
          mobile ? styles.upsellMobile : styles.upsellDesktop
        }`}
      >
        <p className={styles.upsellTitle}>Get the latest jobs in your inbox</p>
        <p>💼 Freelance + remote jobs</p>
        <p>⚡️ Easy applications</p>
        <p>📋 Portfolio + web builder</p>
        <Button
          href="/signup"
          className={styles.upsellButton}
          bsStyle="primary"
        >
          Sign up for free
        </Button>
      </div>
    );
  }

  return null;
};

UpsellSignUp.propTypes = {
  user: PropTypes.object,
  mobile: PropTypes.bool,
};

UpsellSignUp.defaultProps = {
  mobile: false,
};

export default UpsellSignUp;
